import React from 'react';
import { Box, Typography, Link } from '@mui/material';

interface PublicFooterProps {
  // 流入計測用の ref。公開注文=order / 公開予約=reservation。
  refSource: string;
}

/**
 * 公開画面（公開注文・公開予約）の最下部フッター。
 * FEAST ORDER ロゴ＋サービス紹介文を、ref 付きの feast.co.jp リンクとして配置する。
 * 画面最下部に来るよう、利用側でページ全体を minHeight:100vh の flex column にして末尾に置く。
 */
const PublicFooter: React.FC<PublicFooterProps> = ({ refSource }) => {
  const href = `https://feast.co.jp?ref=${encodeURIComponent(refSource)}`;

  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        py: 3,
        px: 2,
        textAlign: 'center',
        borderTop: '1px solid',
        borderColor: 'divider',
        backgroundColor: 'grey.50',
      }}
    >
      <Link
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        underline="none"
        aria-label="FEAST Order 店内オーダー・予約管理（feast.co.jp を開く）"
        sx={{
          display: 'inline-flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 0.5,
          color: 'inherit',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
          <Box
            component="img"
            src={`${process.env.PUBLIC_URL || ''}/lp/feast-logo.svg`}
            alt="FEAST"
            sx={{ height: '22px', width: 'auto', display: 'block' }}
          />
          <Typography
            component="span"
            sx={{
              color: '#F46B4D',
              fontWeight: 700,
              fontSize: '16px',
              lineHeight: 1,
              transform: 'translateY(0.12em)',
              ml: 1,
              letterSpacing: '0.5px',
              textTransform: 'uppercase',
            }}
          >
            Order
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary">
          店内オーダー・予約管理
        </Typography>
      </Link>
    </Box>
  );
};

export default PublicFooter;
